import { render, staticRenderFns } from "./OnlineConsultReply.vue?vue&type=template&id=384bf282&scoped=true"
import script from "./OnlineConsultReply.vue?vue&type=script&lang=js"
export * from "./OnlineConsultReply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384bf282",
  null
  
)

export default component.exports